import type React from "react"
import { useState } from "react"
import { Transfer } from "../../../../../types"
import { Gifts } from "../../../../../types/enum/GiftShop"
import {
  ArtificialItems,
  Item,
  ItemComponents,
  ShinyItems
} from "../../../../../types/enum/Item"
import { getGameContainer } from "../../game"

// Only rendered in dev mode (MODE=dev), never reaches production
export function GameDebugPanel() {
  const [gold, setGold] = useState("100")
  const [level, setLevel] = useState("5")
  const [stage, setStage] = useState("10")
  const [lifeLock, setLifeLock] = useState(false)
  const [collapsed, setCollapsed] = useState(false)

  function send(command: string, value: any) {
    const room = getGameContainer()?.room
    if (room) room.send(Transfer.DEBUG_COMMAND, { command, value })
  }

  function toggleLifeLock() {
    const next = !lifeLock
    setLifeLock(next)
    send("lifelock", next)
  }

  if (collapsed) {
    return (
      <div
        id="game-debug-panel"
        style={{ position: "fixed", top: 8, right: 8, zIndex: 9999 }}
      >
        <button
          onClick={() => setCollapsed(false)}
          style={btnStyle("#555")}
          title="Open debug panel"
        >
          🛠
        </button>
      </div>
    )
  }

  return (
    <div
      id="game-debug-panel"
      style={{
        position: "fixed",
        top: 8,
        right: 8,
        zIndex: 9999,
        background: "rgba(0,0,0,0.85)",
        border: "1px solid #f90",
        borderRadius: 8,
        padding: "8px 12px",
        color: "#f90",
        fontFamily: "monospace",
        fontSize: 13,
        display: "flex",
        flexDirection: "column",
        gap: 6,
        minWidth: 220
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 2
        }}
      >
        <span style={{ fontWeight: "bold" }}>🛠 DEV</span>
        <button onClick={() => setCollapsed(true)} style={btnStyle("#333")}>
          ✕
        </button>
      </div>

      <Row label="金钱">
        <input
          style={inputStyle}
          value={gold}
          onChange={(e) => setGold(e.target.value)}
          type="number"
          min={0}
          max={999}
        />
        <button style={btnStyle("#1a6")} onClick={() => send("gold", gold)}>
          设置
        </button>
      </Row>

      <Row label="等级">
        <input
          style={inputStyle}
          value={level}
          onChange={(e) => setLevel(e.target.value)}
          type="number"
          min={2}
          max={9}
        />
        <button style={btnStyle("#1a6")} onClick={() => send("level", level)}>
          设置
        </button>
      </Row>

      <Row label="回合">
        <input
          style={inputStyle}
          value={stage}
          onChange={(e) => setStage(e.target.value)}
          type="number"
          min={1}
          max={50}
        />
        <button style={btnStyle("#c44")} onClick={() => send("stage", stage)}>
          跳转
        </button>
      </Row>

      <Row label="锁血">
        <button
          onClick={toggleLifeLock}
          style={{
            ...btnStyle(lifeLock ? "#c44" : "#333"),
            border: lifeLock ? "1px solid #f55" : "1px solid #666",
            minWidth: 60
          }}
        >
          {lifeLock ? "🔒 开启" : "🔓 关闭"}
        </button>
      </Row>

      <Row label="百变怪">
        <button style={btnStyle("#55a")} onClick={() => send("ditto", null)}>
          + 添加到板凳
        </button>
      </Row>

      <Row label="变隐龙">
        <button style={btnStyle("#55a")} onClick={() => send("kecleon", null)}>
          + 添加到板凳
        </button>
      </Row>

      <div style={{ borderTop: "1px solid #555", marginTop: 2, paddingTop: 4 }}>
        <div style={{ marginBottom: 4, opacity: 0.7 }}>散件装备</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
          {ItemComponents.map((item: Item) => (
            <img
              key={item}
              src={`assets/item/${item}.png`}
              title={item}
              onClick={() => send("item", item)}
              style={{
                width: 32,
                height: 32,
                cursor: "pointer",
                borderRadius: 4,
                border: "1px solid #555",
                background: "#111"
              }}
              onMouseEnter={(e) => (e.currentTarget.style.borderColor = "#f90")}
              onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#555")}
            />
          ))}
        </div>
      </div>

      <div style={{ borderTop: "1px solid #555", marginTop: 2, paddingTop: 4 }}>
        <div style={{ marginBottom: 4, opacity: 0.7 }}>闪光道具</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
          {ShinyItems.map((item: Item) => (
            <img
              key={item}
              src={`assets/item/${item}.png`}
              title={item}
              onClick={() => send("shinyItem", item)}
              style={{
                width: 32,
                height: 32,
                cursor: "pointer",
                borderRadius: 4,
                border: "1px solid #555",
                background: "#111"
              }}
              onMouseEnter={(e) => (e.currentTarget.style.borderColor = "#f90")}
              onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#555")}
            />
          ))}
        </div>
      </div>

      <div style={{ borderTop: "1px solid #555", marginTop: 2, paddingTop: 4 }}>
        <div style={{ marginBottom: 4, opacity: 0.7 }}>人造道具</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
          {ArtificialItems.map((item: Item) => (
            <img
              key={item}
              src={`assets/item/${item}.png`}
              title={item}
              onClick={() => send("artificialItem", item)}
              style={{
                width: 32,
                height: 32,
                cursor: "pointer",
                borderRadius: 4,
                border: "1px solid #555",
                background: "#111"
              }}
              onMouseEnter={(e) => (e.currentTarget.style.borderColor = "#f90")}
              onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#555")}
            />
          ))}
        </div>
      </div>

      <div style={{ borderTop: "1px solid #555", marginTop: 2, paddingTop: 4 }}>
        <div style={{ marginBottom: 4, opacity: 0.7 }}>礼物盒</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
          {Gifts.map((item: Item) => (
            <img
              key={item}
              src={`assets/item/${item}.png`}
              title={item}
              onClick={() => send("gift", item)}
              style={{
                width: 32,
                height: 32,
                cursor: "pointer",
                borderRadius: 4,
                border: "1px solid #555",
                background: "#111"
              }}
              onMouseEnter={(e) => (e.currentTarget.style.borderColor = "#f90")}
              onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#555")}
            />
          ))}
        </div>
      </div>

      <div style={{ borderTop: "1px solid #555", marginTop: 2, paddingTop: 4 }}>
        <div style={{ marginBottom: 4, opacity: 0.7 }}>券</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
          {[Item.EXCHANGE_TICKET, Item.RECYCLE_TICKET].map((item: Item) => (
            <img
              key={item}
              src={`assets/item/${item}.png`}
              title={item}
              onClick={() => send("ticket", item)}
              style={{
                width: 32,
                height: 32,
                cursor: "pointer",
                borderRadius: 4,
                border: "1px solid #555",
                background: "#111"
              }}
              onMouseEnter={(e) => (e.currentTarget.style.borderColor = "#f90")}
              onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#555")}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

function Row({
  label,
  children
}: {
  label: string
  children: React.ReactNode
}) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <span style={{ width: 36, flexShrink: 0 }}>{label}</span>
      {children}
    </div>
  )
}

const inputStyle: React.CSSProperties = {
  width: 56,
  background: "#222",
  color: "#fff",
  border: "1px solid #555",
  borderRadius: 4,
  padding: "2px 4px",
  fontFamily: "monospace",
  fontSize: 13
}

function btnStyle(bg: string): React.CSSProperties {
  return {
    background: bg,
    color: "#fff",
    border: "none",
    borderRadius: 4,
    padding: "2px 8px",
    cursor: "pointer",
    fontFamily: "monospace",
    fontSize: 12
  }
}
